import slice from "./reportSlice";

export default slice.reducer;
